// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../common/Components/Label.bs.js");
let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Callout = require("../common/Components/Callout.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let Redirect = require("../../reason/common/Redirect.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let SwitchToAgentProfileDialog = require("./SwitchToAgentProfileDialog.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ShareTeamMarketingProfileDialog = require("./ShareTeamMarketingProfileDialog.bs.js");
let TeamMarketingProfileSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileSettingsQuery_graphql.bs.js");
let TeamMarketingProfileSettings_page_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.bs.js");
let TeamMarketingProfileSettings_header_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.bs.js");
let TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.bs.js");

let convertFragment = TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function TeamMarketingProfileSettings$Header(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = React.useState(() => false);
  let setShareModalShown = match[1];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(ShareTeamMarketingProfileDialog.make, {
        marketingProfile: marketingProfile.fragmentRefs,
        isOpen: match[0],
        onDismiss: () => setShareModalShown(param => false)
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Marketing Profile",
                className: "text-zinc-800 text-3xl font-medium leading-6"
              }),
              JsxRuntime.jsx(Label.Neutral.make, {
                text: "Team Profile"
              })
            ],
            className: "flex items-center gap-3 justify-between lg:justify-normal "
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("p", {
              children: "The Marketing Profile is a public page that others can search for or that you can share to promote and showcase the value of your TAN membership.\n"
            }),
            className: "space-y-1 text-base max-w-2xl text-zinc-500"
          })
        ],
        className: "space-y-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => setShareModalShown(param => true),
            className: "",
            children: "Share Profile"
          }),
          JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            href: Scalars.URL.toString(marketingProfile.publicUrl),
            target: "_blank",
            children: "View Profile"
          })
        ],
        className: "flex flex-row gap-4"
      })
    ],
    className: "flex justify-between flex-col lg:flex-row lg:items-end gap-8 border-b pb-6"
  });
}

let Header = {
  Fragment: Fragment,
  make: TeamMarketingProfileSettings$Header
};

function TeamMarketingProfileSettings$PlanCallout(props) {
  return JsxRuntime.jsx(Callout.Warning.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Upgrade to PRO to make your profile look even better."
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
            href: "/plans",
            size: "small",
            children: "Upgrade to PRO",
            color: "TanBlue"
          })
        })
      ],
      className: "flex flex-col gap-4"
    }),
    title: "You currently have a limited version of the marketing profile"
  });
}

let PlanCallout = {
  make: TeamMarketingProfileSettings$PlanCallout
};

let convertFragment$1 = TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink(props) {
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsx(ButtonsV5.Link.make, {
      href: props.url,
      children: JsxRuntime.jsx("span", {
        children: props.text,
        className: "underline"
      })
    })
  });
}

let ActionLink = {
  make: TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink
};

function TeamMarketingProfileSettings$IncompleteProfileCallout(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, props.marketingProfile);
  let teamPhoto = marketingProfile.teamPhoto;
  let members = marketingProfile.members;
  let logo = marketingProfile.logo;
  let about = marketingProfile.about;
  let __x = teamPhoto !== undefined && logo !== undefined && about !== undefined && members !== undefined ? members.totalCount <= 0 : true;
  return ReactRender.ifTrue(JsxRuntime.jsx(Callout.Info.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Your marketing profile is active but appears to be lacking some content. Follow these steps to improve it:"
        }),
        JsxRuntime.jsxs("ul", {
          children: [
            teamPhoto !== undefined ? (
                logo !== undefined ? null : JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                    text: "Add your team's logo",
                    url: "/account/team_marketing_profile/photos"
                  })
              ) : (
                logo !== undefined ? JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                    text: "Add your team's group photo",
                    url: "/account/team_marketing_profile/photos"
                  }) : JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                    text: "Add your team's logo and group photo",
                    url: "/account/team_marketing_profile/photos"
                  })
              ),
            about !== undefined ? null : JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                text: `Update the "about" section for your team`,
                url: "/account/team_marketing_profile/about"
              }),
            members !== undefined && members.totalCount === 0 ? JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                text: "Add your team's members",
                url: "/account/team_marketing_profile/members"
              }) : null
          ],
          className: "list-disc list-inside flex flex-col gap-2"
        })
      ],
      className: "flex flex-col gap-3"
    }),
    title: "Complete your marketing profile"
  }), __x);
}

let IncompleteProfileCallout = {
  Fragment: Fragment$1,
  ActionLink: ActionLink,
  make: TeamMarketingProfileSettings$IncompleteProfileCallout
};

function TeamMarketingProfileSettings$SettingsLinks$Setting(props) {
  return JsxRuntime.jsxs(Link, {
    href: props.url,
    className: "border rounded-lg p-4 flex justify-between items-center",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.name,
            className: "text-zinc-800 text-base font-semibold"
          }),
          JsxRuntime.jsx("div", {
            children: props.description,
            className: "text-zinc-600"
          })
        ],
        className: "space-y-3"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "arrow-right",
          className: "h-4 w-4 text-zinc-600"
        })
      })
    ]
  });
}

let Setting = {
  make: TeamMarketingProfileSettings$SettingsLinks$Setting
};

function descriptionOfPage(page) {
  switch (page) {
    case "BasicInfo" :
      return "Update your team name, brokerage, and website";
    case "Photos" :
      return "Update your team's logo and group photo";
    case "About" :
      return "Update your team's about section";
    case "SocialMedia" :
      return "Link to your team's social media accounts";
    case "Members" :
      return "Update your team's members";
    case "Url" :
      return "Personalize the URL for your profile.";
  }
}

function TeamMarketingProfileSettings$SettingsLinks(props) {
  let subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Update your profile",
            className: "text-zinc-800 text-2xl font-medium leading-6"
          }),
          JsxRuntime.jsx("p", {
            children: "Note that updating your Marketing Profile does not affect how you appear to other agents and clients on TAN. Your TAN Profile is what determines how you appear to others on the platform.",
            className: "text-base text-zinc-500"
          })
        ],
        className: "space-y-2"
      }),
      JsxRuntime.jsx("div", {
        children: subpages.map(page => JsxRuntime.jsx(TeamMarketingProfileSettings$SettingsLinks$Setting, {
          name: page.displayName,
          description: descriptionOfPage(page.page),
          url: page.path
        })),
        className: "space-y-6"
      })
    ],
    className: "space-y-6"
  });
}

let SettingsLinks = {
  Setting: Setting,
  descriptionOfPage: descriptionOfPage,
  make: TeamMarketingProfileSettings$SettingsLinks
};

function TeamMarketingProfileSettings$ChangeProfileTypeSection(props) {
  let match = React.useState(() => false);
  let setIsDialogOpen = match[1];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SwitchToAgentProfileDialog.make, {
        isOpen: match[0],
        onDismiss: () => setIsDialogOpen(param => false)
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Switch to an agent profile",
            className: "text-zinc-800 text-xl font-medium leading-6"
          }),
          JsxRuntime.jsx("p", {
            children: "Your current marketing profile is designed for a team. If you wish to switch back to a single agent profile, click the button below.",
            className: "text-base text-zinc-500 "
          })
        ],
        className: "space-y-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          onClick: param => setIsDialogOpen(param => true),
          size: "small",
          children: "Switch to agent profile"
        }),
        className: "space-y-4"
      })
    ],
    className: "space-y-4 border-t border-zinc-200 pt-6"
  });
}

let ChangeProfileTypeSection = {
  make: TeamMarketingProfileSettings$ChangeProfileTypeSection
};

let convertFragment$2 = TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function TeamMarketingProfileSettings$Page(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, props.marketingProfile);
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let switchToAgentProfileEnabled = FeaturesV3.useFeatureFlipper("SwitchTeamToAgentMarketingProfile") === "on";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(TeamMarketingProfileSettings$Header, {
          marketingProfile: marketingProfile.fragmentRefs
        }),
        ReactRender.ifFalse(JsxRuntime.jsx(TeamMarketingProfileSettings$PlanCallout, {}), hasFullProfile),
        ReactRender.ifTrue(JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout, {
          marketingProfile: marketingProfile.fragmentRefs
        }), hasFullProfile),
        JsxRuntime.jsx(TeamMarketingProfileSettings$SettingsLinks, {}),
        ReactRender.ifTrue(JsxRuntime.jsx(TeamMarketingProfileSettings$ChangeProfileTypeSection, {}), switchToAgentProfileEnabled)
      ],
      className: "space-y-6"
    }),
    className: "bg-white p-6 shadow-sm rounded space-y-8"
  });
}

let Page = {
  Fragment: Fragment$2,
  make: TeamMarketingProfileSettings$Page
};

let convertVariables = TeamMarketingProfileSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$3 = RescriptRelay_Query.useQuery(convertVariables, TeamMarketingProfileSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, TeamMarketingProfileSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(TeamMarketingProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(TeamMarketingProfileSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$3,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileSettings(props) {
  let match = use$3(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  switch (marketingProfile.__typename) {
    case "AgentMarketingProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/marketing_profile"
      });
    case "TeamMarketingProfile" :
      return JsxRuntime.jsx(TeamMarketingProfileSettings$Page, {
        marketingProfile: marketingProfile.fragmentRefs
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = TeamMarketingProfileSettings;

exports.Header = Header;
exports.PlanCallout = PlanCallout;
exports.IncompleteProfileCallout = IncompleteProfileCallout;
exports.SettingsLinks = SettingsLinks;
exports.ChangeProfileTypeSection = ChangeProfileTypeSection;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
